import styled from 'styled-components';

const CPFBody = styled.div`
    border: 0.063rem solid ${props => props.theme.color};
    font-size: 0.75rem;
    border-top: none;

    &:nth-of-type(even) {
        background-color: #EEEEEE;
    }

    .cpf_month {
        padding: 0.688rem 0 0.688rem 1.25rem;
        width: 19%;
    }

    .cpf_paid {
        width: 22.5%;
        padding: 0.688rem 0 0.688rem 0.875rem;
    }

    .cpf_amount {
        padding: 0.688rem 0 0.688rem 0.875rem;
        width: 16.5%;
    }

    .cpf_contribution {
        width: 42%;
        padding: 0.688rem 1.25rem 0.688rem 0.938rem;
    }
`;

export default CPFBody;